export default __webpack_public_path__ + "static/media/user.7a63bf4f.png";